<template>
  <div class='appointment-details__guests-modal'>
    <h3 class='modal__title'>{{ commonMaxPeople }}</h3>
    <div class='appointment-details__guests-modal-subheading'>{{ appointmentsMaxAdults }}</div>
    <div class='flex items-center justify-between py-3 border-b border-[#E1E4EB]'>
      <span class='appointment-details__guests-modal-value-title'>{{ commonPeople }}</span>
      <div class='flex items-center gap-4'>
        <span class='appointment-details__guests-modal-number-btn' @click="subtractValue('adults')"><i class='icon-minus'></i></span>
        <input class='appointment-details__guests-modal-input' v-model='adults' type='number' readonly>
        <span class='appointment-details__guests-modal-number-btn' @click="addValue('adults')"><i class='icon-plus'></i></span>
      </div>
    </div>

    <div class='flex justify-between mt-3'>
      <span class='theme-btn theme-btn--text' @click='resetGuests'>
          <i class='icon-replay' style='font-size: 20px;'></i>
          {{ commonResetGuests }}
      </span>
      <span class='theme-btn theme-btn--theme' @click='saveGuests'>{{ commonSaveAndClose }}</span>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      max_guests: {
        default: 20,
        type: Number,
      },
      commonPeople: {
        default: '',
        type: String,
      },
      commonMaxPeople: {
        default: '',
        type: String,
      },
      commonSaveAndClose: {
        default: '',
        type: String,
      },
      commonResetGuests: {
        default: '',
        type: String,
      },
      appointmentsMaxAdults: {
        default: '',
        type: String,
      },
    },
    data() {
      return {
        adults: 1,
      };
    },
    methods: {
      resetGuests: function() {
        this.adults = 1;
      },
      saveGuests: function() {
        this.$emit('update_guests', this.adults);
        this.$emit('close_modal');
      },
      subtractValue: function(dataName) {
        if (this[dataName] <= 1) return;
        this[dataName]--;
      },
      addValue: function(dataName) {
        if (dataName === 'adults' && this[dataName] === this.max_guests) return;
        this[dataName]++
      },
    },
  };
</script>